import React, { useState, useEffect, useRef } from 'react'
import BackLogo from '../../../../../images/rewampimages/Chevron.png'
import moment from 'moment'
import { paginationFuction } from '../CommonUtils';
import { getALlHubListByData, deleteHubByHubId, changeHubStatusbyId, DownloadOverviewHubByData, DownloadHubTargetReportExcelByData } from './ActionCreator';
import { getAllstateListDistrictByType } from '../../../Marketing/maketingComponents/actioncreator';

import Loader from '../../../../presentationals/Loader/Loader.component';
import Popup from '../../../../presentationals/Popup/Popup.component'
import { styled } from '@mui/material/styles';
import Switch from '@mui/material/Switch';
import TrackChangesIcon from '@mui/icons-material/TrackChanges';

const menuItemStyle = {
    padding: "10px 16px",
    cursor: "pointer",
    whiteSpace: "nowrap",
};

const size = 10;

export default function List({ pageViewHandler, handleTabchange }) {
    const [loader, setLoader] = useState(false)
    const [ListData, setListData] = useState([])
    const [pageNumber, setPageNumber] = useState(0)
    const [totalCount, setTotalCount] = useState(1)
    const [popup, setPopup] = useState({ show: false, popupStatus: "" })

    const [stateList, setStateList] = useState([])
    const [districtList, setDistrcitList] = useState([])
    const [downloadListPopup, setDownloadListPopup] = useState({ inputData: { state: "", city: "", productType: "" }, show: false })
    const [open, setOpen] = useState(false);
    const [targetDownload, setTargetDownload] = useState({ show: false, start: "", end: "" })

    const menuRef = useRef(null);

    const paginationHandlerNew = (type, pageNo) => {
        paginationFuction(type, pageNo + 1, totalCount, callBack => {
            setPageNumber(callBack)
            getALlHubListByDataFn(callBack)
        })
    }

    const actionHandler = (type, data) => {
        if (type == "add") {
            handleTabchange("add", "")
        }
        else if (type == "edit") {
            handleTabchange("add", data)
        }
        else if (type == "info") {
            handleTabchange("DetailsMain", data)
        }
        else if (type == "targets") {
            handleTabchange("targets", data)
        }
        else if (type == "delete") {
            deleteHubByHubIdFn(data)
        }

    }

    useEffect(() => {
        getALlHubListByDataFn(0)
        getAllstateListDistrictByTypeFn()

        const handler = (e) => {
            if (menuRef.current && !menuRef.current.contains(e.target)) {
                setOpen(false);
            }
        };
        document.addEventListener("mousedown", handler);
        return () => document.removeEventListener("mousedown", handler);

    }, [])

    const getAllstateListDistrictByTypeFn = () => {
        setLoader(true)
        getAllstateListDistrictByType("", callback => {
            setLoader(false)
            setStateList(callback?.data || [])
        })
    }

    const getALlHubListByDataFn = (pageNo) => {
        setLoader(true)
        getALlHubListByData(pageNo, size, callBack => {
            setLoader(false)
            setListData(callBack?.data?.data)
            setTotalCount(callBack?.data?.totalElements)
        })
    }

    const deleteHubByHubIdFn = (data) => {
        setLoader(true)
        deleteHubByHubId(data?.hubId, callBack => {
            setLoader(false)
            setPageNumber(0)
            getALlHubListByDataFn(0)
            if (callBack?.message == "success") {
                setPopup({ show: true, popupStatus: 'Hub Deleted Successfully' })
            } else {
                setPopup({ show: true, popupStatus: 'Error Deleting Hub' })
            }
            removePopup()
        })
    }

    const closePopup = () => {
        setPopup({ show: false, popupStatus: '' })
    }

    const removePopup = () => {
        setTimeout(() => {
            closePopup()
        }, 5000)
    }

    const handleSwitchChange = (data, isActive) => {

        setLoader(true)
        changeHubStatusbyId(data?.hubId, !isActive, callBack => {
            setLoader(false)
            setPageNumber(0)
            getALlHubListByDataFn(0)
        })
    }

    const handleDownloadList = (value) => {
        setDownloadListPopup({ inputData: { state: "", city: "", productType: "" }, show: value })
    }

    const handlechangesinPopupData = (e, type) => {
        setDownloadListPopup((prev) => ({
            ...prev,
            inputData: {
                ...prev.inputData,
                [type]: e.target.value
            }
        }))
        if (type == "state") {
            const ar = stateList?.filter((el) => el?.state == e.target.value)
            setDistrcitList(ar?.[0]?.cities || [])
        }
    }

    const downloadReport = () => {
        setLoader(true)
        DownloadOverviewHubByData("", "", "", downloadListPopup?.inputData?.state, downloadListPopup?.inputData?.city, downloadListPopup?.inputData?.productType, callback => {
            setLoader(false)
            console.log("downoad")
        })
    }

    const downloadTargetReport = () => {
        setLoader(true)
        const s = moment(targetDownload?.start).format("DD-MM-YYYY")
        const e = moment(targetDownload?.end).format("DD-MM-YYYY")
        DownloadHubTargetReportExcelByData("", s, e, callback => {
            setLoader(false)
            setTargetDownload({ show: false, start: "", end: "" })
        })
    }
    return (
        <>
            {
                loader ? <Loader /> : ''
            }
            {
                popup?.show ? <Popup popupStatus={popup?.popupStatus} closePopup={closePopup} /> : ""
            }
            <div className='' style={{ marginTop: '10px', marginBottom: window.innerWidth > 1800 ? '100px' : '10px', display: 'inline-flex', alignItems: 'center', marginLeft: '15px' }} onClick={(e) => pageViewHandler(e, 'landingPage')}>
                <img src={BackLogo} alt="" width={'15%'} style={{ marginRight: '10px', cursor: 'pointer' }} />
                {/* <h5 style={{ cursor: 'pointer' }}>Back</h5> */}
                <h4 style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>HUB Management</h4>
            </div>
            <div className='communitySection' style={{ marginTop: '20px' }}>
                <div className="container-fluid">
                    <div className="row">
                        <div className='col-sm-12 col-md-3 mt-1' >
                            <div className='btn-group' >
                                <button
                                    className='cred-btn center-block'
                                    onClick={(e) => actionHandler('add', "")}
                                    style={{ padding: '11px 12px', background: '#064254' }}><i style={{ fontSize: '20px' }} className='fa fa-plus' /></button>
                                {/* <button
                                    className='cred-btn center-block'
                                    // onClick={(e) => handleDownloadList(true)}
                                    onClick={(e) => setShowDownloadPopup(true)}
                                    style={{ padding: '11px 12px', background: '#064254', position: 'relative' }}>
                                    <i style={{ fontSize: '20px' }} className='fa fa-download' />

                                    <div style={{ position: 'absolute', bottom: '-100px', zIndex: '10', borderRadius: '8px', boxShadow: '3px 3px 3px 3px #eee', padding: '10px', background: '#fff' }}>
                                        <ul style={{ listStyleType: 'none' }}>
                                            <li>Hub Data</li>
                                            <li>Target Data</li>
                                        </ul>
                                    </div>

                                </button> */}
                                <div ref={menuRef} style={{ position: "relative", display: "inline-block" }}>
                                    <button
                                        className="cred-btn center-block"
                                        onClick={() => setOpen((p) => !p)}
                                        style={{
                                            padding: "11px 12px",
                                            background: "#064254",
                                            borderRadius: "6px",
                                        }}
                                    >
                                        <i style={{ fontSize: "20px", color: "#fff" }} className="fa fa-download" />
                                    </button>

                                    {open && (
                                        <div
                                            style={{
                                                position: "absolute",
                                                top: "110%",
                                                left: 0,
                                                zIndex: 10,
                                                borderRadius: "8px",
                                                boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                                                padding: "8px 0",
                                                background: "#fff",
                                                minWidth: "160px",
                                            }}
                                        >
                                            <ul style={{ listStyle: "none", margin: 0, padding: 0 }}>
                                                <li
                                                    style={menuItemStyle}
                                                    onClick={() => {
                                                        setOpen(false);
                                                        handleDownloadList(true)
                                                    }}
                                                >
                                                    Hub Data
                                                </li>
                                                <li
                                                    style={menuItemStyle}
                                                    onClick={() => {
                                                        setOpen(false);
                                                        setTargetDownload({ show: true, start: "", end: "" })
                                                    }}
                                                >
                                                    Target Data
                                                </li>
                                            </ul>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>

                        <div className="col-xs-12" style={{ marginTop: '20px' }}>
                            <div className='table-responsive full-height'>
                                {ListData?.length > 0 ?
                                    <>
                                        <div style={{ overflowX: 'auto' }}>
                                            <table className='table credhub-table'>
                                                <thead>

                                                    <tr>
                                                        <th scope="col">Info</th>
                                                        <th scope="col">Hub Code</th>
                                                        <th scope="col">Hub Name</th>
                                                        <th scope="col">Hub Manager Name</th>
                                                        <th scope="col">State</th>
                                                        <th scope="col">City</th>
                                                        <th scope="col">Added On</th>
                                                        <th scope="col">Active</th>
                                                        <th scope="col">Edit</th>
                                                    </tr>

                                                </thead>
                                                <tbody>
                                                    {ListData?.map((row, i) => {
                                                        return (

                                                            <tr key={i}>
                                                                <td>
                                                                    <i className='fa fa-info-circle'
                                                                        onClick={e => actionHandler("info", row)}
                                                                    />
                                                                </td>
                                                                <td>{row?.hubId}</td>
                                                                <td>{row?.hubName}</td>
                                                                <td>{row?.hubManagerName}</td>
                                                                <td>{row?.state}</td>
                                                                <td>{row?.city}</td>
                                                                <td>{row?.addedOn} </td>
                                                                <td>
                                                                    <AntSwitch inputProps={{ 'aria-label': 'ant design' }} checked={row.active == true}
                                                                        onChange={() => handleSwitchChange(row, row.active)} />
                                                                </td>

                                                                <td>
                                                                    <button className='btn action-btn'
                                                                        onClick={e => actionHandler('targets', row)}
                                                                    >
                                                                        <TrackChangesIcon style={{ cursor: 'pointer' }} />
                                                                    </button>
                                                                    <button className='btn action-btn'
                                                                        onClick={e => actionHandler('edit', row)}
                                                                    >
                                                                        <i className='fa fa-edit' />
                                                                    </button>
                                                                    <button className='btn action-btn'
                                                                        onClick={e => actionHandler('delete', row)}
                                                                    >
                                                                        <i className='fa fa-trash-o' />
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        )
                                                    })}
                                                </tbody>
                                            </table>
                                        </div>
                                        <CustomPagination
                                            paginationHandlerNew={paginationHandlerNew}
                                            totalCount={totalCount}
                                            pageNumber={pageNumber}
                                            initalPageNo={0}
                                        />
                                    </>
                                    : null}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {
                downloadListPopup?.show ?
                    <div className="background-blur">

                        <div className="popup-main small-popup container-fluid max-width-500px dbl-border " style={{ padding: '20px', borderRadius: '10px' }}>
                            <i onClick={() => handleDownloadList(false)} style={{ float: "right", marginTop: '-18px', marginRight: '-17px', fontSize: '20px', color: 'red' }} className="fa fa-times-circle"></i>
                            <div className="row from-group">
                                <div className="col-xs-12" style={{ padding: '10px' }}>
                                    <h4 className="text-center" style={{ marginBottom: '10px', marginTop: '10px' }}>Download Report</h4>
                                </div>
                            </div>
                            <div className="row from-group">
                                <div className="col-sm-4 col-xs-12">
                                    <label htmlFor="">State</label>
                                    <select className='form-control' value={downloadListPopup?.inputData?.state} onChange={(e) => handlechangesinPopupData(e, "state")}>
                                        <option value={""}>Select State</option>
                                        {
                                            stateList?.length > 0 ? stateList?.map((val, id) => {
                                                return (
                                                    <option value={val?.state}>{val?.state}</option>
                                                )
                                            })
                                                : ""}
                                    </select>
                                </div>
                                <div className="col-sm-4 col-xs-12">
                                    <label htmlFor="">City</label>
                                    <select className='form-control' value={downloadListPopup?.inputData?.city} onChange={(e) => handlechangesinPopupData(e, "city")}>
                                        <option value={""}>Select City</option>
                                        {
                                            districtList?.length > 0 ? districtList?.map((val) => {
                                                return (
                                                    <option value={val}>{val}</option>
                                                )
                                            })
                                                : ""
                                        }
                                    </select>
                                </div>
                                <div className="col-sm-4 col-xs-12">
                                    <label htmlFor="">Product Type</label>
                                    <select className='form-control' value={downloadListPopup?.inputData?.productType} onChange={(e) => handlechangesinPopupData(e, "productType")}>
                                        <option value={""}>Select Product</option>
                                        <option value="L3">Three-Wheeler L3</option>
                                        <option value="L5">Three-Wheeler L5</option>
                                        <option value="BATTERY">BATTERY</option>

                                    </select>
                                </div>
                            </div>
                            <div className="row from-group text-center">
                                <div className="col-xs-12">
                                    <button className="btn btn-primary" style={{ marginTop: '10px', borderRadius: '5px', border: '1px solid #D3D9E9', boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)', background: '#2B78FF' }} onClick={() => downloadReport()}>Save</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    : ""}
            {
                targetDownload?.show ?
                    <div className="background-blur">

                        <div className="popup-main small-popup container-fluid max-width-500px dbl-border " style={{ padding: '20px', borderRadius: '10px' }}>
                            <i onClick={() => setTargetDownload({ show: false, start: "", end: "" })} style={{ float: "right", marginTop: '-18px', marginRight: '-17px', fontSize: '20px', color: 'red' }} className="fa fa-times-circle"></i>
                            <div className="row from-group">
                                <div className="col-xs-12" style={{ padding: '10px' }}>
                                    <h4 className="text-center" style={{ marginBottom: '10px', marginTop: '10px' }}>Download Report</h4>
                                </div>
                            </div>
                            <div className="row from-group">

                                <div className="col-sm-6 col-xs-12">
                                    <label htmlFor="">Start Date</label>
                                    <input className='form-control' value={targetDownload?.start} type='date' onChange={(e) => setTargetDownload((prev) => ({ ...prev, start: e.target.value }))} />
                                </div>
                                <div className="col-sm-6 col-xs-12">
                                    <label htmlFor="">End Date</label>
                                    <input className='form-control' value={targetDownload?.end} type='date' onChange={(e) => setTargetDownload((prev) => ({ ...prev, end: e.target.value }))} />
                                </div>

                            </div>
                            <div className="row from-group text-center">
                                <div className="col-xs-12">
                                    <button className="btn btn-primary" style={{ marginTop: '10px', borderRadius: '5px', border: '1px solid #D3D9E9', boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)', background: '#2B78FF' }} onClick={() => downloadTargetReport()}>Save</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    : ""}
        </>
    )
}


const CustomPagination = ({ totalCount, pageNumber, paginationHandlerNew, initalPageNo }) => {
    return (
        <>
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-sm-4 col-xs-12 paginationBtn' onClick={() => paginationHandlerNew('main-left', pageNumber)}>
                        <button className='' style={{ width: '100%', color: '#fff' }} >
                            <i className='fa fa-angle-double-left'></i>
                        </button>
                    </div>
                    <div className='col-sm-1 col-xs-12 paginationBtn-small' onClick={() => paginationHandlerNew('left', pageNumber)}>
                        <button className='' style={{ width: '100%', color: '#fff' }}>
                            <i className='fa fa-angle-left'></i>
                        </button>
                    </div>
                    <div className='col-sm-2 col-xs-12 text-center'>
                        <div className=''>
                            <div> Page Number : {initalPageNo == 0 ? pageNumber + 1 : pageNumber}</div>

                            <div> Total Counts :{totalCount}</div>
                        </div>
                    </div>
                    <div className='col-sm-1 col-xs-12 paginationBtn-small' onClick={() => paginationHandlerNew('right', pageNumber)}>
                        <div>
                            <button className='' style={{ width: '100%', color: '#fff' }}>
                                <i className='fa fa-angle-right'></i>
                            </button>
                        </div>
                    </div>
                    <div className='col-sm-4 col-xs-12 paginationBtn' onClick={() => paginationHandlerNew('main-right', pageNumber)}>
                        <button className='' style={{ width: '100%', color: '#fff' }} >
                            <i className='fa fa-angle-double-right'></i>
                        </button>
                    </div>
                </div>
            </div>
        </>
    )
}

const AntSwitch = styled(Switch)(({ theme }) => ({
    width: 28,
    height: 16,
    padding: 0,
    margin: "auto",
    display: 'flex',
    '&:active': {
        '& .MuiSwitch-thumb': {
            width: 15,
        },
        '& .MuiSwitch-switchBase.Mui-checked': {
            transform: 'translateX(9px)',
        },
    },
    '& .MuiSwitch-switchBase': {
        padding: 2,
        '&.Mui-checked': {
            transform: 'translateX(12px)',
            color: '#fff',
            '& + .MuiSwitch-track': {
                opacity: 1,
                backgroundColor: '#13d61dff',
                ...theme.applyStyles('dark', {
                    backgroundColor: '#13d61dff',
                }),
            },
        },
    },
    '& .MuiSwitch-thumb': {
        boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
        width: 12,
        height: 12,
        borderRadius: 6,
        transition: theme.transitions.create(['width'], {
            duration: 200,
        }),
    },
    '& .MuiSwitch-track': {
        borderRadius: 16 / 2,
        opacity: 1,
        backgroundColor: 'rgba(0,0,0,.25)',
        boxSizing: 'border-box',
        ...theme.applyStyles('dark', {
            backgroundColor: 'rgba(255,255,255,.35)',
        }),
    },
}));